var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"porter__option"},[_c('input',{attrs:{"type":"checkbox"},on:{"input":function($event){$event.preventDefault();$event.stopPropagation();return _vm.check.apply(null, arguments)}}}),_vm._v(" Check all\n")])}
var staticRenderFns = []

export { render, staticRenderFns }